<template>
              <div class="search-result-list" v-for="item in items" track-by="$index">
                <p class="head">
                  <span class="{{ fileIcon(item.fileext) }}"></span>
                  <!-- 未登录状态下 -->
                  <a v-if="stype!=5&&stype != 10" style="cursor:pointer;"  @click="checkLogin(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                  <a v-if="stype == 10" style="cursor:pointer;"  @click="openAbsAnn(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                  <!-- 跳转详情页面 -->
                  <a v-if="stype==5" style="cursor:pointer;" @click="checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                </p>
                <p class="Subtitle">
                  {{ item.publishDate ? item.publishDate: item.uploadTime }}
                  <span class="marginlf-10">{{ item.companyCode }}</span>
                  <span class="marginlf-10" v-if="item.author">作者: {{ item.author }}</span>
                  <span class="marginlf-10" v-if="item.nickname">公众号: {{ item.nickname }}</span>
                </p>
                <p class="lien" v-if="item.content && item.content!='NoContent'">
                  {{{ item.content.join('...... ') }}}
                </p>


                <template v-if="item.child">
                  <template v-for="child in item.child">
                    <!-- <p class="blak font-weight lien" :style="indentChild(child.code)">{{{ child.title }}}</p> -->
                    <p class="blak font-weight lien child-title" :style="indentChild(child.code)" @click="viewChildTitle(item, child.code)" style="cursor:pointer;">
                      {{{ child.title }}}
                    </p>
                    <p class="lien" :style="indentChild(child.code)" v-if="child.content">
                      {{{ child.content.join('...... ') }}}
                    </p>
                    <template v-if="child.contents">
                      <template v-for="c in child.contents">
                        <p class="lien" :style="indentChild(child.code)" v-if="c.htmltag=='p'">
                          {{{ c.content }}}</br>
                        </p>
                        <template  v-if="c.htmltag=='table'">
                          <div class="table-result-outter">
                            <table cellpadding="0" class="table-result">
                              <tbody>
                              <tr v-for="(rowidx, row) in c.table" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                                <td v-for="(colidx, col) in row" rowspan="{{ col.row }}" colspan="{{ col.col }}" track-by="$index"> {{{col.value}}} </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="table-whole">
                            <a href="javascript:;" @click="viewTable(item, child.code, c.offset), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')">
                              <span class="table-see-icon "></span>查看表格全部内容
                            </a>
                          </div>
                        </template>
                      </template>
                    </template>

                    <!-- 研报图表 -->
                    <div class="intelligent-fsearch-cont" v-if="child.imgs">
                      <template  v-for="c in child.imgs">
                        <div class="fsearch-a">

                          <div class="more-img" style="cursor:pointer;" title="点击查看更多" @click="setBigImgObj(c, item)">
                            <img :src="c.imgurl">
                          </div>
                          <div class="text-a">{{{child.title}}}</div>
                          <div class="text-b" style="cursor:pointer" @click="viewImg(item, child.code, c.offset)">{{{c.imghead}}}</div>
                          <div class="text-b" style="cursor:pointer" @click="viewImg(item, child.code, c.offset)">{{{c.imgfoot}}}</div>
                        </div>
                      </template>
                    </div><!-- /研报图表 -->
                  </template>
                </template>
              </div>
<div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8;">
  <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
    <img src="/static/images/loading.gif" width="150" />
  </div>
</div>
<bigimg :bigimgobj="bigImgObj" v-if="bigImgObj.show"></bigimg>
</template>  
<script>

  import {apiUrl, dateFormat, alert, isEmptyObj} from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/SearchMix'
  import commentMix from '../notice/commentMix'
  // import myDatepicker from '../../helper/datepicker.vue'
  import wxshareMix from '../../common/wxshareMix'
  import commonMix from '../../common/comSearchMix.js'
  import searchResMix from '../../common/searchResMix.js'
  import BigImg from '../BigImg.vue'
export default {
    mixins: [userMix, wxshareMix,  searchMix, commentMix, commonMix, searchResMix],
    components: {
      'bigimg': BigImg,
      // 'date-picker': myDatepicker
    },
  props: {
    currentuser: {
      default: {},
      type: Object
    }, 
    stype: {
      default: 1,
      type: Number
    }, 
    items: {
      default: [],
      type: Array
    },
    onlytitle: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      showratingLogic: false,
      showriskWarning: false,
      showsummary: false,
      showviewPoint: false,
      currentNoticeDetail: null,
      defaultFilter: null,
      defaultProperty: null,
      simplepage: 1,
      simpletotalpage: 0,
      showsimpleNotice: false,
      simpletotal: 0,
      simpleNotice: [],  
      loading: false,
      bigImgObj: {'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': ''},
      rightMap: {'type': '研报类型', 'company': '相关公司', 'tbcompany': '图表提到的公司', 'tblabel': '相关指标', 'tbsource': '数据来源', 'tbproduct': '相关产品', 'authors': '相关分析师', 'broker': '研究机构', 'SWHYIndustry': '相关行业', 'docrating': '相关评级', 'docratingChange': '评级变化'},
    }
  },
  created: function () {
    console.log(this.onlytitle)
    console.log(this.stype)
    console.log(this.items)
  },
  computed: {
    simpleindexs () {
      let left = 1
      let right = this.simpletotalpage
      let ar = []
      if (this.simpletotalpage >= 11) {
        if (this.simplepage > 5 && this.simplepage < this.simpletotalpage - 4) {
          left = this.simplepage - 5
          right = this.simplepage + 4
        } else {
          if (this.simplepage <= 5) {
            left = 1
            right = 10
          } else {
            right = this.simpletotalpage
            left = this.simplepage - 9
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      return ar
    },
  },
  methods: {
    goABS (k) {
      let url = '/#!/abs?norname=' + k
      window.open(url)
    },
    // 单一条件搜索
    simpleSearch: function (property, arg) {
      if (this.stype !== 11 && this.stype !== 13) {
        return false
      }
      this.defaultFilter = arg
      this.defaultProperty = property
      let query = {'conditions': {'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {}, 'tbcompany': {}, 'company': {}, 'tblabel': {}, 'tbsource': {}, 'tbproduct': {}, 'authors': {}, 'broker': {}, 'SWHYIndustry': {}, 'docrating': {}, 'docratingChange': {}}, 'stype': 11, 'ttype': 0, 'keywords': '', 'companyCode': '', 'datetype': 98, 'startdate': '', 'enddate': '', 'keywords_condition': [{'val': '', 'ttype': 0, 'ttname': '全部', 'optype': 1, 'opname': '包含全部关键词'}], 'perPage': 10, 'page': this.simplepage, 'sort': 1}
      
      query.conditions[property][arg] = arg
      
      console.log(query)
      this.loading = true
      $.ajax({
        url: apiUrl('/V1.0.0/notice/search'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          // if (response.lists.length == 0) {
          //   alert('暂无结果')
          //   return false
          // }
          this.simpleNotice = response.lists
          this.simpletotalpage = response.totalPage
          // if (response.total > 0) {
            this.simpletotal = response.total
            this.showsimpleNotice = true
          // }
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
      })
    },
    exportTable (item, tcode, offset, ext) {
      if (!this.checkPrivilege('search/exporttable', '暂无权限')) {
          return false
      }
      console.log(item)
      // return false
      $.ajax({
        url: apiUrl('/V1.0.0/user/checkaction'),
        method: 'post',
        dataType:'json',
        async: false,
        data: JSON.stringify({'action': 'search/exporttable'})
      }).done((response) => {
        if (response.status == 0) {
          let _offset = parseInt(offset) + 1
          let tcode1 = ''
          if (tcode === '1') {
            tcode1 = 'undefined'
          } else {
            tcode1 = tcode
          }
          let _tcode = tcode1 + '-' + _offset.toString()  // 表格id
          if (ext) {
            var url = 'http://' + this.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&ext=1'
          } else {
            var url = 'http://' + this.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode
          }
          this.downloadFile(url)
          console.log(url)
        } else if (response.status == 300) {
          let that = this
          confirm(response.description, function () {
            let _offset = parseInt(offset) + 1
            let tcode1 = ''
            if (tcode === '1') {
              tcode1 = 'undefined'
            } else {
              tcode1 = tcode
            }
            let _tcode = tcode1 + '-' + _offset.toString()  // 表格id
            if (ext) {
              var url = 'http://' + that.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + that.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&ext=1'
            } else {
              var url = 'http://' + that.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + that.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode
            }
            that.downloadFile(url)
            console.log(url)
          })
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
        return false
      })

    },
    downloadFile (url, name) {
      var link = document.createElement('a')
      link.download = name
      link.href = url
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    setBigImgObj: function (item, article) {
      console.log(item);
      console.log(article);
      this.bigImgObj.imghead = item.imghead
      this.bigImgObj.imgfoot = item.imgfoot
      this.bigImgObj.imgurl = item.imgurl
      this.bigImgObj.imgid = item.imgid

      this.bigImgObj.companycode = article.companyCode;
      this.bigImgObj.companyname = article.companyName;
      this.bigImgObj.md5 = article.id;
      this.bigImgObj.publishdate = article.publishDate;
      // this.bigImgObj.shortname = article.shortname;
      this.bigImgObj.stype = this.stype;
      this.bigImgObj.title = article.title;

      this.bigImgObj.show = true
      this.bigImgObj.modal = 1;
      let bigimgo = Object.assign(this.bigImgObj)
    },
    checkLoginBefD: function (item, x) {
      // this.currentuser = null
      
        if (!this.checkPrivilege('search/download', '暂无权限')) {
          return false
        }

        $.ajax({
          url: apiUrl('/V1.0.0/user/checkaction'),
          method: 'post',
          dataType:'json',
          async: false,
          data: JSON.stringify({'action': 'search/download'})
        }).done((response) => {
          if (response.status == 300) {
            confirm(response.description, function () {
              $('#download_' + x).css('display', 'block')
              $('.download_' + x).css('display', 'none')
              let url = item.downloadurl
              if (document.cookie.indexOf('embed=1') < 0) {
                window.open(url)
              } else {
                window.location.href = url
              }
              setTimeout(function () {
                $('#download_' + x).css('display', 'none')
                $('.download_' + x).css('display', 'block')
              }, 1500)
            })

          } else if (response.status == 0) {
            $('#download_' + x).css('display', 'block')
            $('.download_' + x).css('display', 'none')
            let url = item.downloadurl
            if (document.cookie.indexOf('embed=1') < 0) {
              window.open(url)
            } else {
              window.location.href = url
            }
            setTimeout(function () {
              $('#download_' + x).css('display', 'none')
              $('.download_' + x).css('display', 'block')
            }, 1500)
          } else {
            alert(response.description)
          }
        }).fail((response) => {
          alert('请求失败')
          return false
        }) 
    },
    // 获取指标结果 stype == 14
    nationstatdatalist: function (item) {
      
      this.loading = true
      // $('.kSvFYT .jmdbRq').remove()
      // $('.kSvFYT').append(`<div class="jmdbRq"> <div class="ubscribe-news-no">
      //                   <div class="ubscribe-news-no-cont">
      //                     <img src="/static/images/loading1.gif">
      //                   <p class="center">加载中...</p>
      //                  </div> 
      //                 </div>   
      //               </div>`)
      var newWin = window.open()
      $.ajax({
        url: apiUrl('/V1.0.0/notice/nationstatdatalist'),
        method: 'post',
        dataType: 'json',
        data:JSON.stringify({did: item.zb_detail_id})
      }).done((response) => {
        this.loading = false
        if (response.status === 0) {
          let data = response.data
          data.sort(function (a, b) {return parseInt(a.data_time.replace(/-/g, '')) - parseInt(b.data_time.replace(/-/g, ''))})
          
          data.forEach((x) => {
            if (x.data) {
              x.data = Math.round(x.data * 1000) / 1000
            }
            return x
          })
          let obj = {}
          obj.frequency = item.zb_frequency
          obj.unit = item.zb_norm_unit
          obj.name = item.zb_type_name + "-" + item.zb_reg_name
          obj.starttime = data[0].data_time
          obj.endtime = data[data.length - 1].data_time

          // 改成新页面打开，用localStorage传递参数
          window.localStorage.chartData = JSON.stringify(data)
          window.localStorage.chartType = 'line'
          window.localStorage.chartDetail = JSON.stringify(obj)
          
          newWin.location.href = '/#!/complex?chartStatus=1'

          // this.$emit('chartcontent', {data: data, type: 'line', detail: obj})
          // this.$emit('showdata')
          // this.$nextTick(() => {
          //   this._searchMix_complexChart(data, 'line', obj)
          // })

        } else {
          alert(response.description)
         
        }
      }).fail((response) => {
        this.loading = false
        alert('请求失败')
        
      })
      
    },

    setCnzz (name, action, label) {
      window._czc.push(['_trackEvent', name, action, label])
      console.log(name + ' : ' + action + ' : ' + label)
    },
  }

}
</script>



/** WEBPACK FOOTER **
 ** resultFrag.vue?65272990
 **/